import { type IDataObject } from '@inpart-io/devtools-iap';
import { RECEIVE_DATA_OBJECTS, STORE_DATA_OBJECTS } from '@inpart-io/devtools-vue';
import { type ILeadProfile, leadProfilesManager } from '@inpart-io/padme-iap';
import { type ActionTree } from 'vuex';

import { isDataObject } from '@/services/data-object-helper';

import { PRIVATE_ASSET_MODULE } from '../private-asset-module';
import { PRIVATE_COMPANY_MODULE } from '../private-company-module';
import { PRIVATE_CONSUMER_HEALTH_ASSET_MODULE } from '../private-consumer-health-asset-module';
import { PRIVATE_TECHNOLOGY_MODULE } from '../private-technology-module';

export const UPDATE_LINK = 'updateLink';
export const OVERRIDE_EVALUATE = 'overrideEvaluate';

export const actions: ActionTree<ILeadProfile, unknown> = {
    async [UPDATE_LINK](
        context,
        { profileId, directoryAssetId, properties }: { profileId: number; directoryAssetId?: number; properties?: string }
    ): Promise<void> {
        const updated = await leadProfilesManager.updateLink(profileId, directoryAssetId, { properties });
        return context.dispatch(STORE_DATA_OBJECTS, { dataObjectList: [updated] });
    },
    async [OVERRIDE_EVALUATE](
        context,
        { profileId, evaluateId, oldId, properties }: { profileId: number; evaluateId: number; oldId?: number; properties?: string }
    ): Promise<void> {
        const updated = await leadProfilesManager.overrideEvaluate(profileId, evaluateId, oldId, { properties });
        return context.dispatch(STORE_DATA_OBJECTS, { dataObjectList: [updated] });
    },
    [STORE_DATA_OBJECTS](context, { dataObjectList }: { dataObjectList: ILeadProfile[] }) {
        const assetProfiles: ILeadProfile[] = [];
        const leadAssetEntities: IDataObject[] = [];
        const leadTechnologyEntities: IDataObject[] = [];
        const leadConsumerHealthEntities: IDataObject[] = [];
        const leadCompanyEntities: IDataObject[] = [];

        dataObjectList.forEach((assetProfile) => {
            const _assetProfile = Object.assign({}, assetProfile);
            if (isDataObject<IDataObject>(assetProfile.asset)) {
                const assetEntity = Object.assign({}, assetProfile.asset);
                _assetProfile.assetEntity = assetEntity.dobjId;
                if (assetProfile.assetCategory === 'TEC') {
                    leadTechnologyEntities.push(assetEntity);
                } else if (assetProfile.assetCategory === 'COH') {
                    leadConsumerHealthEntities.push(assetEntity);
                } else if (assetProfile.assetCategory === 'COM') {
                    leadCompanyEntities.push(assetEntity);
                } else {
                    leadAssetEntities.push(assetEntity);
                }
            }

            assetProfiles.push(_assetProfile);
        });

        if (assetProfiles.length > 0) {
            context.commit(RECEIVE_DATA_OBJECTS, { dataObjectList: assetProfiles });
        }
        if (leadAssetEntities.length > 0) {
            void context.dispatch(`${PRIVATE_ASSET_MODULE}/${STORE_DATA_OBJECTS}`, { dataObjectList: leadAssetEntities }, { root: true });
        }
        if (leadConsumerHealthEntities.length > 0) {
            void context.dispatch(
                `${PRIVATE_CONSUMER_HEALTH_ASSET_MODULE}/${STORE_DATA_OBJECTS}`,
                { dataObjectList: leadConsumerHealthEntities },
                { root: true }
            );
        }
        if (leadCompanyEntities.length > 0) {
            void context.dispatch(`${PRIVATE_COMPANY_MODULE}/${STORE_DATA_OBJECTS}`, { dataObjectList: leadCompanyEntities }, { root: true });
        }
        if (leadTechnologyEntities.length > 0) {
            void context.dispatch(`${PRIVATE_TECHNOLOGY_MODULE}/${STORE_DATA_OBJECTS}`, { dataObjectList: leadTechnologyEntities }, { root: true });
        }
    }
};
